import { Loader2 } from 'lucide-react';
import { cn } from '../../lib/utils';

export type SpinnerSize = 'sm' | 'md' | 'lg';

const SIZES: Record<SpinnerSize, string> = {
  sm: 'size-3.5',
  md: 'size-4',
  lg: 'size-6',
};

export interface SpinnerProps {
  className?: string;
  /** Visible text next to the spinner; without it a screen-reader label is used. */
  label?: string;
  size?: SpinnerSize;
}

export function Spinner({ className, label, size = 'md' }: SpinnerProps) {
  return (
    <span role="status" aria-live="polite" className="inline-flex items-center gap-2">
      <Loader2 className={cn('animate-spin text-muted', SIZES[size], className)} aria-hidden />
      {label ? (
        <span className="text-sm text-muted">{label}</span>
      ) : (
        <span className="sr-only">Loading</span>
      )}
    </span>
  );
}
